import { Controller, Post, Body, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ExitActionDTO } from './dto/exit-action.dto';
import { AllExitActionsResponseModel, ExitActionResponseModel } from '@gtpl/shared-models/hrms';
import { ExitActionRequest } from './dto/exit-action.request';
import { ExitActionService } from './exit-action.service';

@ApiTags('exit-action')
@Controller('exit-action')
export class ExitActionController {
    constructor(
        private service: ExitActionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createExitAction')
    async createExitAction(@Body() DTO: ExitActionDTO, isUpdate: boolean = false): Promise<ExitActionResponseModel>{
        try{
            return await this.service.createExitAction(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ExitActionResponseModel, error);
        }
    }

    @Post('/updateExitAction')
    async updateExitAction(@Body() DTO: ExitActionDTO, isUpdate: boolean = false): Promise<ExitActionResponseModel>{
        try{
            return await this.service.createExitAction(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ExitActionResponseModel, error);
        } 
    }

    @Post('/getAllExitActions')
    async getAllExitActions(): Promise<AllExitActionsResponseModel>{
        try{
            return await this.service.getAllExitActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllExitActionsResponseModel, error);
        }
    }

    @Post('/getAllActiveExitActions')
    async getAllActiveExitActions(): Promise<AllExitActionsResponseModel>{
        try{
            return await this.service.getAllActiveExitActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllExitActionsResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateExitAction')
    async activateOrDeactivate(@Body() req: ExitActionRequest): Promise<ExitActionResponseModel>{
        try{
            return await this.service.activateOrDeactivateExitAction(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ExitActionResponseModel, error)
        }
    }
}
